import React from 'react';
import { Link } from 'react-router-dom';
import { HomeIcon, ArrowLeftIcon } from '@heroicons/react/24/outline';

const NotFound = () => {
    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
            <div className="max-w-md w-full space-y-8 text-center">
                <div>
                    <h1 className="mt-6 text-6xl font-bold text-gray-900">404</h1>
                    <h2 className="mt-2 text-2xl font-semibold text-gray-700">Page Not Found</h2>
                    <p className="mt-4 text-lg text-gray-500">
                        Sorry, we couldn't find the page you're looking for.
                    </p>
                </div>
                
                <div className="space-y-4">
                    <div className="flex flex-col sm:flex-row gap-3 justify-center">
                        <Link
                            to="/"
                            className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200"
                        >
                            <HomeIcon className="h-5 w-5 mr-2" />
                            Go Home
                        </Link>
                        
                        <button
                            onClick={() => window.history.back()}
                            className="inline-flex items-center px-6 py-3 border border-gray-300 text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200"
                        >
                            <ArrowLeftIcon className="h-5 w-5 mr-2" />
                            Go Back
                        </button>
                    </div>
                    
                    <div className="text-sm text-gray-400">
                        <p>If you believe this is an error, please contact support.</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NotFound;
